<template>
  <div id="required-info-list">
    <vs-row style="flex-wrap: wrap-reverse" v-if="enterpriseKind == 2">
      <vs-col vs-lg="9" vs-sm="12">
        <div>
          <div class="list-controller">
            <div class="filter-area">
              <search-input
                class="filter-input"
                placeholder="必要情報名"
                :onInputEnter="onSearchEnter"
              ></search-input>
              <hull-dropdown-select
                class="filter-input"
                :selectOptions="filteredInputTypeSelectOptions"
                :onSelect="onSelectInputTypeFilter"
                :selectedValue.sync="selectedInputType"
                placeholder="形式"
                clearable
                :bordered="false"
              ></hull-dropdown-select>
            </div>

            <paging-navigation
              :startItemNumber="startItemNumber"
              :endItemNumber="endItemNumber"
              :totalItemNumber="totalItemNumber"
              :isPreviousActive="isPreviousPage"
              :isNextActive="isNextPage"
              :onPreviousClick="onPreviousPage"
              :onNextClick="onNextPage"
              :onSelectDisplayNumber="onSelectDisplayNumber"
            >
            </paging-navigation>
          </div>

          <hull-list
            :data="data"
            :columns="columns"
            :pagination="true"
            :displayItems="displayItems"
            :incrementSearch="false"
            :onClickEdit="openEditModal"
            :onClickDelete="openDeleteModal"
            :isSearchResultNoData="isSearchResultNoData"
            :noDataRegistered="noDataRegistered"
            :onClickLinkString="openDescriptionModal"
          >
            <template v-slot:isSearchResultNoData>
              <div class="list-message-label aisea-text-20-400-gray-black">
                検索条件に一致する必要情報が見つかりませんでした。
              </div>
            </template>
            <template v-slot:noDataRegistered>
              <div class="list-message-label aisea-text-20-400-gray-black">
                必要情報が登録されていません。
              </div>
              <common-button
                title="必要情報登録"
                icon="add"
                :click="clickAddClaimTypeButton"
              ></common-button>
            </template>
          </hull-list>

          <common-modal title="必要情報マスター登録" ref="EditModal">
            <template v-slot:contents>
              <div class="required-info-edit-form-container">
                <div class="form-item">
                  <div class="form-item-title">
                    必要情報名
                    <span class="required-mark">*</span>
                  </div>
                  <div class="input-area">
                    <vs-input
                      v-model="editRequiredInfoName"
                      color="#2D9CDB"
                      class="full-width-input"
                    />
                  </div>
                </div>
                <div class="form-item">
                  <div class="form-item-title">
                    情報形式
                    <span class="required-mark">*</span>
                  </div>
                  <div class="input-area">
                    <input-type-dropdown-select
                      class="filter-input"
                      :selectOptions="filteredInputTypeSelectOptions"
                      :onSelect="onEditSelectInputType"
                      :selectedValue.sync="editSelectedInputType"
                      :onViewButtonClick="showLightbox"
                      :viewButton="editSelectedInputType != null ? true : false"
                      :border="true"
                      :disabled="isEditMode"
                    ></input-type-dropdown-select>
                  </div>
                </div>
                <div
                  class="form-scroll-area"
                  v-if="isEditSelectedInputTypeNeedOption"
                >
                  <div class="option-form-area">
                    <common-text-box-option
                      class="option-form-item"
                      v-for="(step, index) in mandatoryOptions"
                      :key="index"
                      :formLabel="'選択肢' + (index + 1)"
                      :required="true"
                      :deleteButton="false"
                      :value.sync="mandatoryOptions[index]"
                      ref="mandatoryOption"
                      :disabled="isEditMode"
                    >
                      <feather-icon
                        v-if="editSelectedInputType == 4"
                        icon="CheckSquareIcon"
                        class="mr-3"
                        svg-classes="h-5 w-5"
                      />
                      <feather-icon
                        v-else-if="editSelectedInputType == 5"
                        icon="ChevronDownIcon"
                        class="mr-3"
                        svg-classes="h-5 w-5"
                      />
                      <feather-icon
                        v-else-if="editSelectedInputType == 6"
                        icon="CircleIcon"
                        class="mr-3"
                        svg-classes="h-5 w-5"
                      />
                    </common-text-box-option>

                    <common-text-box-option
                      class="option-form-item"
                      v-for="(step, index) in formOptions"
                      :key="index + 3"
                      :formLabel="'選択肢' + (index + 3)"
                      :required="true"
                      :deleteButton="isAddMode"
                      :value.sync="formOptions[index]"
                      :onClickDelete="() => deleteStep(index)"
                      :disabled="isEditMode"
                    >
                      <feather-icon
                        v-if="editSelectedInputType == 4"
                        icon="CheckSquareIcon"
                        class="mr-3"
                        svg-classes="h-5 w-5"/>
                      <feather-icon
                        v-else-if="editSelectedInputType == 5"
                        icon="ChevronDownIcon"
                        class="mr-3"
                        svg-classes="h-5 w-5"/>
                      <feather-icon
                        v-else-if="editSelectedInputType == 6"
                        icon="CircleIcon"
                        class="mr-3"
                        svg-classes="h-5 w-5"
                    /></common-text-box-option>
                    <common-add-button
                      v-if="isAddMode"
                      class="add-option-button"
                      :click="addFormOption"
                      title="選択肢を追加"
                      icon="PlusIcon"
                    ></common-add-button>
                  </div>
                </div>

                <div class="form-item">
                  <div class="form-item-title">
                    管理者専用説明（任意）
                    ※保険契約者の画面に表示されません。(文字数制限120文字)
                  </div>
                  <vs-textarea
                    v-model="descriptionOwner"
                    :counter="120"
                    :counter-danger.sync="invalidDescriptionOwnerLength"
                  />
                </div>
                <div class="form-item">
                  <div class="form-item-title">
                    保険契約者向け説明（任意）
                    ※保険契約者の画面に表示されます。(文字数制限120文字)
                  </div>
                  <vs-textarea
                    v-model="descriptionInsurer"
                    :counter="120"
                    :counter-danger.sync="invalidDescriptionInsurerLength"
                  />
                </div>

                <div class="continually-add-check" v-if="isAddMode">
                  <vs-checkbox
                    class="checkbox"
                    v-model="isContinuallyAdd"
                    color="#48a0f4"
                    >続けて作成</vs-checkbox
                  >
                </div>

                <div class="button-area">
                  <common-button
                    class="button"
                    title="キャンセル"
                    :click="closeEditModal"
                    color="#BDBDBD"
                    text-color="#757575"
                    type="border"
                  ></common-button>
                  <common-button
                    class="button"
                    title="登録"
                    :click="isAddMode ? callAdd : callEdit"
                    :disabled="!isFormValidated"
                  ></common-button>
                </div>
              </div>
            </template>
          </common-modal>
          <common-modal title="" ref="DeleteModal">
            <template v-slot:contents>
              <div class="delete-container">
                必要情報を削除します。よろしいですか？
                <div class="button-area">
                  <common-button
                    class="button"
                    title="キャンセル"
                    :click="closeDeleteModal"
                    color="#BDBDBD"
                    text-color="#757575"
                    type="border"
                  ></common-button>
                  <common-button
                    class="button"
                    title="削除"
                    :click="() => callDelete(selectedItemId)"
                  ></common-button>
                </div>
              </div>
            </template>
          </common-modal>

          <common-modal title="" ref="DescriptionModal">
            <template v-slot:contents>
              <div class="description-container">
                <div class="description-title">
                  管理者専用説明
                </div>
                <div class="description-content">
                  {{ displayDescriptionOwner }}
                </div>
                <div class="description-title mt-8">
                  保険契約者向け説明
                </div>
                <div class="description-content">
                  {{ displayDescriptionInsurer }}
                </div>
              </div>
            </template>
          </common-modal>
        </div>
      </vs-col>
      <vs-col class="right-widget-area" vs-lg="3" vs-sm="12">
        <hull-navigation-select
          class="mb-4"
          menuButtonLabel="メニュー"
          :menuItemOptions="getMenuItemOptions(this.$route.name)"
        >
        </hull-navigation-select>

        <common-button
          title="必要情報登録"
          icon="add"
          :click="clickAddClaimTypeButton"
        ></common-button>
        <claim-count-label
          itemLabel="必要情報登録数"
          :count="totalItemNumber"
          class="my-4"
        ></claim-count-label>
      </vs-col>
    </vs-row>
    <div v-else-if="enterpriseKind == 1">
      <no-access-label></no-access-label>
    </div>
    <light-box
      ref="lightbox"
      v-if="lightBoxMediaList.length != 0"
      :media="lightBoxMediaList"
      :show-light-box="false"
      :show-thumbs="false"
      :show-caption="false"
      :disableScroll="false"
    >
    </light-box>
  </div>
</template>

<script>
import HullList from "../components/molecules/HullList";
import SearchInput from "../components/molecules/SearchInput";
import PagingNavigation from "../components/molecules/PagingNavigation";
import CommonModal from "../components/organisms/CommonModal.vue";
import CommonButton from "../components/molecules/CommonButton.vue";
import CommonTextBoxOption from "../components/molecules/CommonTextBoxOption.vue";
import ClaimCountLabel from "../components/molecules/ClaimCountLabel.vue";
import HullNavigationSelect from "../components/molecules/HullNavigationSelect.vue";
import HullDropdownSelect from "../components/molecules/HullDropdownSelect.vue";
import NoAccessLabel from "../components/organisms/NoAccessLabel.vue";
import InputTypeDropdownSelect from "../components/organisms/InputTypeDropdownSelect.vue";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import moment from "moment";
import FireStoreService from "@/services/fireStoreService";
import LightBox from "vue-image-lightbox";
import CommonAddButton from "../components/molecules/CommonAddButton.vue";
const claimItemRepository = AiseaApiFactory.get(
  "hullInsuranceEnterpriseClaimItem"
);

import { HULL_INSURANCE_INPUT_TYPE } from "@/config/const";
import { HullInsranceMixin } from "@/mixins";

export default {
  mixins: [HullInsranceMixin],
  name: "T.RequiredInfoList",
  components: {
    SearchInput,
    PagingNavigation,
    HullList,
    CommonModal,
    CommonButton,
    CommonTextBoxOption,
    ClaimCountLabel,
    HullNavigationSelect,
    HullDropdownSelect,
    NoAccessLabel,
    InputTypeDropdownSelect,
    LightBox,
    CommonAddButton,
  },
  data() {
    return {
      enterpriseKind: null,

      startItemNumber: 0,
      endItemNumber: 0,
      totalItemNumber: 0,
      currentPage: 0,
      pageSize: 10,

      isPreviousPage: false,
      isNextPage: false,

      displayItems: {
        number: 10,
      },
      columns: [
        {
          displayName: "必要情報名",
          inputType: "linkString",
          key: "required_info_name",
          searchable: true,
        },
        {
          displayName: "情報形式",
          inputType: "string",
          key: "info_type",
          searchable: false,
        },
        {
          displayName: "説明",
          inputType: "string",
          key: "description_owner",
          searchable: false,
        },
        {
          displayName: "更新日",
          inputType: "string",
          key: "update_date",
          searchable: false,
        },
      ],
      data: [
        /*
        {
          id: "4",
          claim_type_name: "PA（通常の修繕費）",
          step: "第一報/事故の状況確認/サーベイ",
          update_date: "2023/04/22",
          status: {
            label: "受付中",
            color: "EB5757",
          },
        },
        */
      ],

      searchKeyword: "",
      selectedItemId: null,

      selectedInputType: null,

      inputTypeSelectOptions: HULL_INSURANCE_INPUT_TYPE,

      requiredInfoName: "",

      isContinuallyAdd: false,
      // DescriptionModal
      displayDescriptionOwner: "",
      displayDescriptionInsurer: "",

      // EditModal
      editRequiredInfoName: "",
      editSelectedInputType: null,

      formOptions: [],
      mandatoryOptions: ["", ""],

      descriptionOwner: "",
      descriptionInsurer: "",
      invalidDescriptionOwnerLength: false,
      invalidDescriptionInsurerLength: false,
      editVersion: null,
    };
  },
  async created() {
    this.enterpriseKind = await this.getEnterpriseKind();
    await this.initializeDisplayNumber();
    this.callFetch();
  },
  computed: {
    isVesselOwner() {
      return this.enterpriseKind == 1;
    },
    isInsuranceCompany() {
      return this.enterpriseKind == 2;
    },
    lightBoxMediaList() {
      return HULL_INSURANCE_INPUT_TYPE.filter(element => {
        return element.value == this.editSelectedInputType;
      }).map(element => {
        return {
          src: element.previewSrc,
        };
      });
    },
    isFormValidated() {
      if (this.editRequiredInfoName.trim() == "") return false;
      if (this.editSelectedInputType == null) return false;
      if (this.invalidDescriptionOwnerLength) return false;
      if (this.invalidDescriptionInsurerLength) return false;

      if (this.isEditSelectedInputTypeNeedOption) {
        if (
          !this.checkArrayNotEmpty(this.mandatoryOptions) ||
          !this.checkArrayNotEmpty(this.formOptions)
        )
          return false;
      }
      return true;
    },
    isEditSelectedInputTypeNeedOption() {
      return (
        this.editSelectedInputType == 4 ||
        this.editSelectedInputType == 5 ||
        this.editSelectedInputType == 6
      );
    },
    isSearchResultNoData() {
      return (
        (this.searchKeyword != "" || this.selectedInputType != null) &&
        this.data.length == 0 &&
        this.currentPage == 0
      );
    },
    noDataRegistered() {
      return (
        !this.isSearchResultNoData &&
        this.data.length == 0 &&
        this.currentPage == 0
      );
    },
    isEditMode() {
      return this.selectedItemId != null;
    },
    isAddMode() {
      return this.selectedItemId == null;
    },
    filteredInputTypeSelectOptions() {
      return this.inputTypeSelectOptions.filter(element => element.value != 14);
    },
  },
  methods: {
    checkArrayNotEmpty(array) {
      for (let i = 0; i < array.length; i++) {
        if (array[i].trim() === "") {
          return false;
        }
      }
      return true;
    },
    clearOptionForm() {
      this.clearFormOptions();
      this.editRequiredInfoName = "";
      this.editSelectedInputType = null;
      this.descriptionOwner = "";
      this.descriptionInsurer = "";
    },
    clearFormOptions() {
      this.mandatoryOptions.splice(0);
      this.mandatoryOptions.push("");
      this.mandatoryOptions.push("");
      this.formOptions.splice(0);
    },
    addFormOption() {
      this.formOptions.push("");
    },
    deleteStep(index) {
      this.formOptions.splice(index, 1);
    },
    showLightbox() {
      this.$refs.lightbox.showImage(0);
    },
    async initializeDisplayNumber() {
      const res = await FireStoreService.getAccountSetting(
        "required_info_list"
      );
      if (res && res.page_size) {
        this.pageSize = res.page_size;
      } else {
        this.pageSize = 10;
      }
    },
    saveDisplayNumberInFireStore() {
      FireStoreService.setAccountSetting("required_info_list", {
        page_size: this.pageSize,
      });
    },
    onEditSelectInputType() {
      this.clearFormOptions();
    },
    onSelectInputTypeFilter(value) {
      this.selectedInputType = value;
      this.currentPage = 0;
      this.callFetch();
    },
    onSelectDisplayNumber(number) {
      this.pageSize = number;
      this.currentPage = 0;
      this.saveDisplayNumberInFireStore();
      this.callFetch();
    },
    onSearchEnter(searchKeyword) {
      this.searchKeyword = searchKeyword;
      this.currentPage = 0;
      this.callFetch();
    },
    clickAddClaimTypeButton() {
      this.selectedItemId = null;
      this.clearOptionForm();

      this.$refs.EditModal.show();
    },
    async callFetch() {
      this.$vs.loading();
      const res = await claimItemRepository.fetch({
        name: this.searchKeyword,
        page: this.currentPage,
        size: this.pageSize,
        input_type: this.selectedInputType,
      });
      this.$vs.loading.close();
      if (res.status == true) {
        this.data = res.data.claim_items.map(element => {
          const id = element.id;
          const requiredInfoName = element.name;
          const infoType = this.getInputTypeLabel(element.input_type);
          const inputType = element.input_type;
          const updateDate = element.updated_at;
          const descriptionInsurer = element.description_insurer;
          const descriptionOwner = element.description_owner;
          const choices = element.choices;
          const version = element.version;
          return {
            id: id,
            required_info_name: requiredInfoName,
            info_type: infoType,
            input_type: inputType,
            update_date: moment(updateDate)
              .local()
              .format("YYYY/MM/DD"),
            description_insurer: descriptionInsurer,
            description_owner: descriptionOwner,
            choices: choices,
            version: version,
          };
        });

        this.setPagigation(
          this.currentPage,
          res.data.total_pages,
          this.pageSize,
          res.data.claim_items.length,
          res.data.total_elements
        );
      } else {
        this.$vs.notify({
          title: "必要情報の取得に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
    async callAdd() {
      const choices = [...this.mandatoryOptions, ...this.formOptions];

      const res = await claimItemRepository.add({
        name: this.editRequiredInfoName,
        input_type: this.editSelectedInputType,
        choices: choices,
        description_insurer: this.descriptionInsurer,
        description_owner: this.descriptionOwner,
      });

      if (res.status == true) {
        this.$vs.notify({
          title: "必要情報を追加しました",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
        });
        this.clearOptionForm();
        if (!this.isContinuallyAdd) {
          this.closeEditModal();
        }
        this.callFetch();
      } else if (res.code == 400) {
        this.$vs.notify({
          title: res.message,
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      } else {
        this.$vs.notify({
          title: "必要情報の追加に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
    async callEdit() {
      const choices = JSON.parse(
        JSON.stringify([...this.mandatoryOptions, ...this.formOptions])
      );

      const res = await claimItemRepository.update(this.selectedItemId, {
        name: this.editRequiredInfoName,
        input_type: this.editSelectedInputType,
        choices: choices,
        description_insurer: this.descriptionInsurer,
        description_owner: this.descriptionOwner,
        version: this.editVersion,
      });
      if (res.status == true) {
        this.$vs.notify({
          title: "必要情報を更新しました",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
        });
        this.clearOptionForm();
        this.closeEditModal();
        this.callFetch();
      } else if (res.code == 400) {
        this.$vs.notify({
          title: res.message,
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      } else {
        this.$vs.notify({
          title: "必要情報の更新に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
    },
    setPagigation(
      currentPage,
      totalPage,
      pageSize,
      displayItemNumber,
      totalItemNumber
    ) {
      this.startItemNumber = totalPage == 0 ? 0 : pageSize * currentPage + 1;
      this.endItemNumber =
        totalPage == 0 ? 0 : this.startItemNumber + displayItemNumber - 1;
      this.totalItemNumber = totalItemNumber;
      this.isNextPage = currentPage < totalPage - 1;
      this.isPreviousPage = currentPage > 0;

      this.currentPage = currentPage;
    },
    onPreviousPage() {
      this.currentPage--;
      this.callFetch();
    },
    onNextPage() {
      this.currentPage++;
      this.callFetch();
    },

    setEditModalForm(
      requiredInfoName,
      inputType,
      choices,
      descriptionOwner,
      descriptionInsurer,
      version
    ) {
      this.clearOptionForm();
      this.editRequiredInfoName = requiredInfoName;
      this.editSelectedInputType = inputType;
      if (choices != null) {
        if (choices.length >= 1) {
          this.mandatoryOptions[0] = choices[0] ? choices[0] : "";
        }
        if (choices.length >= 2) {
          this.mandatoryOptions[1] = choices[1] ? choices[1] : "";
        }

        if (choices.length >= 3) {
          for (let i = 2; i < choices.length; i++) {
            this.formOptions.push(choices[i]);
          }
        }
      }

      this.descriptionOwner = descriptionOwner;
      this.descriptionInsurer = descriptionInsurer;
      this.editVersion = version;
    },

    async callDelete(id) {
      this.$vs.loading();
      const res = await claimItemRepository.delete(id);
      this.$vs.loading.close();
      if (res.status == true) {
        this.$vs.notify({
          title: "必要情報を削除しました",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
        });
      } else {
        this.$vs.notify({
          title: "必要情報の削除に失敗しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
      this.closeDeleteModal();
      this.currentPage = 0;
      this.callFetch();
    },
    openEditModal(id) {
      this.selectedItemId = id;

      if (id != null) {
        const found = this.data.find(element => element.id == id);
        this.setEditModalForm(
          found.required_info_name,
          found.input_type,
          found.choices,
          found.description_owner,
          found.description_insurer,
          found.version
        );
      }

      this.$refs.EditModal.show();
    },
    openDeleteModal(id) {
      this.selectedItemId = id;
      this.$refs.DeleteModal.show();
    },
    closeEditModal() {
      this.$refs.EditModal.close();
    },
    closeDeleteModal() {
      this.$refs.DeleteModal.close();
    },
    openFormPreviewModal() {
      this.$refs.FormPreviewModal.show();
    },
    closeFormPreviewModal() {
      this.$refs.FormPreviewModal.close();
    },
    openDescriptionModal(id) {
      const found = this.data.find(element => element.id == id);
      if (found) {
        this.displayDescriptionInsurer = found.description_insurer;
        this.displayDescriptionOwner = found.description_owner;
        this.$refs.DescriptionModal.show();
      }
    },
    closeDescriptionModal() {
      this.$refs.DescriptionModal.close();
    },
  },
};
</script>

<style lang="scss">
#required-info-list {
  .list-controller {
    display: flex;
    margin-bottom: 20px;
    .filter-area {
      flex-grow: 1;
      display: flex;
      .filter-input {
        margin-right: 8px;
        width: 200px;
      }
    }
  }

  .right-widget-area {
    padding-left: 20px;
    max-width: 300px;
  }
  .list-message-label {
    margin: 10px;
  }

  .vue-lb-container {
    z-index: 60000;
  }
}
.required-info-edit-form-container {
  max-height: 650px;
  overflow-y: auto;
  width: 460px;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
  margin-right: auto;

  .continually-add-check {
    margin-top: 10px;
    margin-bottom: 10px;
    width: 100%;
    .checkbox {
      width: fit-content;
    }
  }
  .full-width-input {
    width: 100%;
  }
  .add-option-button {
    width: fit-content;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: auto;
    margin-right: auto;
  }
  .button-area {
    display: flex;
    justify-content: space-around;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 10px;
    .button {
      width: 140px;
    }
  }
  .required-mark {
    color: red;
  }
  .form-item {
    width: 100%;
    margin-bottom: 15px;
  }
  .option-form-item {
    width: 100%;
    margin-bottom: 10px;
  }
  .form-scroll-area {
    margin-top: 10px;
    margin-bottom: 15px;
    max-height: 400px;
    min-height: 200px;
    width: 100%;
    overflow-y: auto;
  }
  .option-form-area {
    width: 100%;
  }
}
.delete-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  .button-area {
    display: flex;
    justify-content: space-between;
    width: 320px;
    margin-top: 20px;
    margin-bottom: 10px;
    .button {
      width: 140px;
    }
  }
}
.description-container {
  .description-title {
    font-weight: bold;
    margin-bottom: 4px;
  }
}
</style>
